var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48982 21.6302L18.8098 14.3102C19.5998 13.8002 20.0698 12.9402 20.0698 12.0002C20.0698 11.0602 19.5998 10.2002 18.8098 9.69019L7.48982 2.37019C6.62982 1.81019 5.57982 1.77019 4.67982 2.26019C3.77982 2.75019 3.23982 3.65019 3.23982 4.68019L3.23982 19.3302C3.23982 20.3502 3.77982 21.2602 4.67982 21.7502C5.57982 22.2402 6.62982 22.2002 7.48982 21.6402L7.48982 21.6302Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow_right_icon.0af8cbfa7af395ae1af68fe2630c75b7.svg";
export { ForwardRef as ReactComponent };